var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1699 16.75C23.8399 19.41 21.6599 21.59 18.9999 21.92C17.3899 22.12 15.8899 21.68 14.7199 20.82C14.0499 20.33 14.2099 19.29 15.0099 19.05C18.0199 18.14 20.3899 15.76 21.3099 12.75C21.5499 11.96 22.5899 11.8 23.0799 12.46C23.9299 13.64 24.3699 15.14 24.1699 16.75Z",
    fill: "url(#paint0_linear_966_4581)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 2C7.83 2 4.25 5.58 4.25 9.99C4.25 14.4 7.83 17.98 12.24 17.98C16.65 17.98 20.23 14.4 20.23 9.99C20.22 5.58 16.65 2 12.24 2ZM11.3 8.87L13.71 9.71C14.58 10.02 15 10.63 15 11.57C15 12.65 14.14 13.54 13.09 13.54H13V13.59C13 14 12.66 14.34 12.25 14.34C11.84 14.34 11.5 14 11.5 13.59V13.53C10.39 13.48 9.5 12.55 9.5 11.39C9.5 10.98 9.84 10.64 10.25 10.64C10.66 10.64 11 10.98 11 11.39C11 11.75 11.26 12.04 11.58 12.04H13.08C13.31 12.04 13.49 11.83 13.49 11.57C13.49 11.22 13.43 11.2 13.2 11.12L10.79 10.28C9.93 9.98 9.5 9.37 9.5 8.42C9.5 7.34 10.36 6.45 11.41 6.45H11.5V6.41C11.5 6 11.84 5.66 12.25 5.66C12.66 5.66 13 6 13 6.41V6.47C14.11 6.52 15 7.45 15 8.61C15 9.02 14.66 9.36 14.25 9.36C13.84 9.36 13.5 9.02 13.5 8.61C13.5 8.25 13.24 7.96 12.92 7.96H11.42C11.19 7.96 11.01 8.17 11.01 8.43C11 8.77 11.06 8.79 11.3 8.87Z",
    fill: "url(#paint1_linear_966_4581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_966_4581",
    x1: 14.3008,
    y1: 17.008,
    x2: 24.2177,
    y2: 17.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_966_4581",
    x1: 4.25,
    y1: 9.99,
    x2: 20.23,
    y2: 9.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGold);
export default __webpack_public_path__ + "static/media/money-gold.375c8699b5bf8e36c6b50b89e50b3b4d.svg";
export { ForwardRef as ReactComponent };